import { combineReducers } from "@ngrx/store";
import { AiInsightState } from "./ai-insight.state";
import { promptsReducer } from "./prompts/prompts.reducer";
import { summaryPromptsReducer } from "./summary-prompts/summary-prompts.reducer";

export const aiInsightReducer = combineReducers<AiInsightState>({
    prompts: promptsReducer,
    summaryPrompts: summaryPromptsReducer
});

